export default "__VITE_ASSET__b3866bb7__"